<template>
  <b-card>
    <validation-observer ref="taxInformationRules">
      <b-form @submit.prevent="saveTaxInformationAction">
        <b-row class="mt-2">
          <b-col md="6">
            <InputField
              id="value-added-tax"
              v-model.number="taxInformationFormData.config.vatPercentage"
              :label="$t('Value Added Tax (%)')"
              :placeholder="$t('Enter value added tax')"
              type="number"
              :error-name="$t('Value Added Tax')"
              rules="required|max-value:100|positive"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <InputField
              id="individual-withholding-tax"
              v-model.number="taxInformationFormData.config.individualWHTPerc"
              :label="$t('Individual Withholding Tax (%)')"
              :placeholder="$t('Enter individual withholding tax')"
              type="number"
              :error-name="$t('Individual Withholding Tax')"
              rules="required|max-value:100|positive"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <InputField
              id="corporate-withholding-tax"
              v-model.number="taxInformationFormData.config.corporateWHTPerc"
              :label="$t('Corporate Withholding Tax (%)')"
              :placeholder="$t('Enter corporate withholding tax')"
              type="number"
              :error-name="$t('Corporate Withholding Tax')"
              rules="required|max-value:100|positive"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>

        <div class="text-center">
          <Button
            v-if="getUserPermission('MODIFY_SYSTEM_SETUP')"
            :label="buttonLabel"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="saveTaxInformation"
          />
        </div>
      </b-form>
    </validation-observer>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { required, maxValue, positive } from '@validations'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import Button from '../../../../components/button/Button.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    InputField,
    BForm,
    ValidationObserver,
    Button,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      required,
      positive,
      maxValue,
      isDisabled: false,
      isReadonly: true,
      isEditable: true,
      isLoading: false,
      showSpinner: false,
      buttonLabel: this.$t('Edit'),
      taxInformationFormData: {
        config: {
          vatPercentage: 0,
          individualWHTPerc: 0,
          corporateWHTPerc: 0,
        },
      },
    }
  },
  mounted() {
    this.fetchTaxInformation()
  },
  methods: {
    ...mapActions({
      getTaxInformation: 'operations/getTaxInformationList',
      updateTaxInformation: 'operations/updateTaxInformationAction',
    }),
    saveTaxInformation() {
      if (this.buttonLabel === this.$t('Save Changes')) {
        this.$refs.taxInformationRules.validate().then(success => {
          if (success) {
            this.confirm(this.handleSubmit, { text: this.$t('Are you sure you want to Update this Tax Information?') })
          }
        })
      } else {
        this.isReadonly = false
        this.isEditable = true
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const response = await this.updateTaxInformation(
          this.taxInformationFormData,
        )
        const { status } = await response
        if (status === 200) {
          this.fetchTaxInformation()
          this.alertSuccess({ text: this.$t('Your request to Update Tax Information was successful') })
          this.isReadonly = true
          this.isEditable = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = 'Edit'
        }
      } catch (error) {
        const requestText = this.$t('Your request to Update Tax Information failed. Reason:')
        this.alertError({ text: `${requestText} ${error}` })
      } finally {
        this.isEditable = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    async fetchTaxInformation() {
      try {
        this.showSpinner = true
        const response = await this.getTaxInformation()
        const { status, data } = response
        if (status === 200 && data.data) {
          this.taxInformationFormData.config = { ...data.data }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
<style scoped>
.custom-checkbox:last-child {
  margin-left: 20px !important;
}
</style>
